import { render, staticRenderFns } from "./WebhookLogs.vue?vue&type=template&id=5b5b3de2&scoped=true&"
import script from "./WebhookLogs.vue?vue&type=script&lang=ts&"
export * from "./WebhookLogs.vue?vue&type=script&lang=ts&"
import style0 from "./WebhookLogs.vue?vue&type=style&index=0&id=5b5b3de2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5b3de2",
  null
  
)

export default component.exports